import React from "react";
import { Link } from "react-router-dom";

const TernaryButton = ({
  text,
  img,
  width,
  event,
  path,
  type = "button",
  uppercase = true,
  mutation = false,
}) => {
  return (
    <>
      {path ? (
        <Link
          to={path}
          className={`shadow-light text-primary text-center border border-primary whitespace-nowrap ${
            !mutation
              ? "py-[10.5px] 2xl:text-[17px] xl:text-[16px] lg:text-xs"
              : "py-[10px] 2xl:text-[15px] xl:text-[14px] lg:text-xs"
          }  rounded-md ${
            uppercase ? "uppercase" : "normal-case"
          } font-semibold tracking-wider relative z-20 outline-none ${
            width ? width : ""
          }`}
        >
          {text}
          {img && <img src={img} alt="" width={17} height={17} />}
        </Link>
      ) : (
        <button
          type={type}
          className={`shadow-light text-primary text-center border border-primary whitespace-nowrap ${
            !mutation
              ? "py-[10.5px] 2xl:text-[17px] xl:text-[16px] lg:text-xs"
              : "py-[10px] 2xl:text-[15px] xl:text-[14px] lg:text-xs"
          }  rounded-md ${
            uppercase ? "uppercase" : "normal-case"
          } font-semibold tracking-wider relative z-20 outline-none ${
            width ? width : ""
          }`}
          onClick={event}
        >
          {text}
          {img && <img src={img} alt="" width={17} height={17} />}
        </button>
      )}
    </>
  );
};

export default TernaryButton;
